<template>
  <div></div>
</template>
<script>
export default {
  name: "DialogConfirm",
  data() {
    return {
      toastInstance: null,
    };
  },
  methods: {
    showAlertConfirm(
      title,
      text,
      icon,
      confirmMessage,
      cancelMessege,
      allowOutsideClick = true,
      showCancelButton = true,
    ) {
      return this.$swal.fire({
        title: title,
        text: text,
        icon: icon || "warning",
        showCancelButton: showCancelButton,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: confirmMessage || "ตกลง",
        cancelButtonText: cancelMessege || "ยกเลิก",
        reverseButtons: true,
        allowOutsideClick: allowOutsideClick,
      });
    },
    show3ButtonsConfirm({
      title,
      text,
      icon,
      confirmMessage,
      denyMessage,
      cancelMessege,
      confirmButtonColor,
      cancelButtonColor,
      denyButtonColor,
      allowOutsideClick = true,
      footer,
    }) {
      return this.$swal.fire({
        title: title,
        text: text,
        icon: icon || "warning",
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonColor, //"#3085d6",
        cancelButtonColor, //"#d33",
        denyButtonColor,

        confirmButtonText: confirmMessage || "ตกลง",
        denyButtonText: denyMessage || "ปฏิเสธ",
        cancelButtonText: cancelMessege || "ยกเลิก",
        reverseButtons: true,
        allowOutsideClick: allowOutsideClick,
        footer: footer || "",
      });
    },
    showAlertInfo(title, text, icon) {
      return this.$swal.fire({
        title: title,
        text: text,
        icon: icon || "info",
      });
    },
    showTimeoutSession() {
      return this.$swal
        .fire({
          title: "เซสชั่นหมดอายุ",
          text: "กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
          icon: "error",
          confirmButtonColor: "#d33",
          confirmButtonText: "ตกลง",
        })
        .then(result => {
          this.$router.push({
            name: "Login",
            query: {
              redirect: this.$route.query.redirect
                ? this.$route.query.redirect
                : this.$route.path,
            },
          });
        });
    },
    showToast(variant, textDetail, noAutoHide = false) {
      let textTitle = "";
      if (variant == "warning") {
        textTitle = "คำเตือน";
      } else if (variant == "success") {
        textTitle = "สำเร็จ";
      } else if (variant == "info") {
        textTitle = "ข้อความแจ้ง";
      } else if (variant == "danger") {
        textTitle = "เกิดข้อผิดพลาด";
      }
      return this.$root.$bvToast.toast(textDetail, {
        title: textTitle,
        variant: variant,
        solid: true,
        noAutoHide: noAutoHide,
        toaster: "b-toaster-bottom-left",
      });
    },
    showToastWithSpinner(
      variant = "info",
      textDetail = "Files Uploading...",
      noAutoHide = false
    ) {
      // Create a temporary div to hold the content with spinner
      const h = this.$createElement;
      const content = h("div", { class: "d-flex align-items-center" }, [
        h(
          "div",
          {
            class: "spinner-border text-primary mr-2",
            attrs: { role: "status" },
          },
          [h("span", { class: "sr-only" }, "Loading...")]
        ),
        h("span", textDetail),
      ]);

      return this.$root.$bvToast.toast(content, {
        id: "my-spinner-toast",
        title: "แจ้งข้อมูล",
        variant: "info",
        solid: true,
        noAutoHide: true,
        toaster: "b-toaster-bottom-left",
      });
    },
    hideToast() {
      this.$root.$bvToast.hide("my-spinner-toast");
    },
    // General purpose method to directly access $swal.fire with any configuration
    fire(config) {
      return this.$swal.fire(config);
    },
  },
};
</script>

<style>
/* Custom styling for SweetAlert2 dialogs */
.swal2-popup.swal2-modal {
  border-radius: 10px;
  padding: 2rem;
}

.swal2-title {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
}

.swal2-html-container {
  font-size: 1.1rem !important;
}

/* Danger confirmation styling */
.swal2-confirm.swal2-styled {
  font-weight: 500;
  padding: 0.5rem 1.5rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* Enhanced styling for dangerous operation confirmations */
.swal2-popup.swal2-modal[class*='warning'],
.swal2-popup.swal2-modal[class*='error'] {
  border-left: 5px solid #dc3545;
}

.swal2-input {
  font-size: 1.1rem !important;
  font-weight: 500;
}

.swal2-validation-message {
  font-weight: 500;
  font-size: 0.9rem !important;
  background-color: #fff3f3 !important;
  color: #d63031 !important;
  border-left: 3px solid #d63031;
  padding: 0.5rem !important;
}
</style>